import BorderRadius from '@omni/kit/theming/BorderRadius';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement, ReactNode } from 'react';
import { Platform, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

interface DropdownProps {
  style?: StyleProp<ViewStyle>;
  children: ReactNode;
}

export default function Dropdown({
  children,
  style = {},
}: DropdownProps): ReactElement {
  return <View style={[styles.dropdown, style]}>{children}</View>;
}

const styles = StyleSheet.create({
  dropdown: {
    backgroundColor: Colors.N0,
    borderRadius: BorderRadius.m,
    overflow: 'hidden',
    paddingVertical: Spacing.s,
    ...Platform.select({
      android: { elevation: 10, overflow: 'hidden' },
      default: {
        shadowColor: '#000000',
        shadowOffset: { height: 3, width: 0 },
        shadowOpacity: 0.06,
        shadowRadius: 6,
      },
    }),
  },
});
